import { TESTIMONIALS } from "../data/content";
import { SectionHeader, CTABand } from "./Home";
import { Quote } from "lucide-react";

export default function TestimonialsPage() {
  return (
    <div data-testid="testimonials-page">
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <SectionHeader
            eyebrow="Testimonials"
            title="The trust of those who verify for a living."
            sub="Lawyers, lenders, developers, and homeowners share why they rely on Terraa & Title for the moments that matter most."
            className="mb-16"
          />
          <div className="grid md:grid-cols-2 gap-6">
            {TESTIMONIALS.map((t) => (
              <figure key={t.name} data-testid={`testimonial-card-${t.name.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="tt-card p-10 flex flex-col">
                <Quote size={28} strokeWidth={1} className="text-[#C1A74A] mb-6" />
                <blockquote className="font-accent italic text-xl text-[#113835] leading-relaxed flex-1">"{t.quote}"</blockquote>
                <figcaption className="mt-8 pt-6 border-t border-[#113835]/10">
                  <p className="font-heading text-sm font-medium text-[#113835]">{t.name}</p>
                  <p className="text-xs text-[#C1A74A] tracking-widest uppercase mt-1">{t.role}</p>
                </figcaption>
              </figure>
            ))}
          </div>
          <p className="mt-12 text-xs text-gray-400 font-light">
            Representative client experiences. Full client references available on request, subject to confidentiality.
          </p>
        </div>
      </section>
      <CTABand />
    </div>
  );
}
